export function isSubdomain(): boolean {
    const hostname = new URL(window.location.href).hostname;
    const parts = hostname.split('.');
    return parts.length > 2;
}